import MiPerfil from "../components/DetailsUser/MiPerfil";

export default function DetailsUser() {
  return <MiPerfil />;
}
